export function PaymentTrustBadges({ oneTimeOnly = false }: { oneTimeOnly?: boolean }) {
  return (
    <div className="mx-auto mt-10 max-w-2xl rounded-lg border border-slate-200 bg-white px-6 py-6 shadow-sm">
      {/* Header: lock + Secure checkout + Razorpay */}
      <div className="flex items-center justify-center gap-2 text-slate-800">
        <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
        </svg>
        <span className="text-sm font-semibold">Secure checkout</span>
        <span className="text-slate-300">·</span>
        <span className="text-sm text-slate-600">
          Powered by{' '}
          <a
            href="https://razorpay.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#0C2451] underline-offset-2 hover:underline"
          >
            Razorpay
          </a>
        </span>
      </div>

      {/* Payment method badges — styled wordmarks, no external images */}
      <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
        <MethodBadge label={oneTimeOnly ? 'UPI' : 'UPI AutoPay'} className="border-emerald-200 bg-emerald-50 text-[#098041]" />
        <MethodBadge label="VISA" className="text-[#1A1F71] tracking-wider" />
        <MethodBadge
          label={
            <span className="flex items-center gap-0.5">
              <span className="h-3 w-3 rounded-full bg-[#EB001B]" />
              <span className="h-3 w-3 -ml-1.5 rounded-full bg-[#F79E1B] mix-blend-multiply" />
              <span className="ml-1 text-[10px] font-semibold text-slate-700">Mastercard</span>
            </span>
          }
        />
        <MethodBadge label="AMEX" className="text-[#006FCF] tracking-wider" />
        <MethodBadge label="RuPay" className="text-[#097D4E]" />
        <MethodBadge label="Netbanking" className="text-slate-700" />
        <MethodBadge label="Wallets" className="text-slate-700" />
      </div>

      {/* Fine print */}
      <p className="mt-4 text-center text-xs text-slate-500">
        {oneTimeOnly
          ? 'Pay securely by UPI, card, netbanking, or wallet · card details never touch our servers'
          : 'Razorpay opens UPI AutoPay first for eligible INR subscriptions · card details never touch our servers'}
      </p>
    </div>
  );
}

function MethodBadge({
  label,
  className = '',
}: {
  label: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex min-w-[52px] items-center justify-center rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-bold ${className}`}
    >
      {label}
    </span>
  );
}
